$mol_button_download $mol_button_minor
	blob null
	uri \
	file_name \blob.bin
	sub /
		<= Icon $mol_icon_download
		<= title \
